import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Accordian/Accordian.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/header/Header.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/heading/heading.scss");
;
import(/* webpackMode: "eager" */ "/app/components/button/button.scss");
;
import(/* webpackMode: "eager" */ "/app/app/srilanka-group-tour/page.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/svg/common/social-icons/whatsapp.svg");
;
import(/* webpackMode: "eager" */ "/app/sections/common/faq-group/faq.scss");
;
import(/* webpackMode: "eager" */ "/app/sections/common/enquiry/enquiry.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/common/footer/contact.tsx");
;
import(/* webpackMode: "eager" */ "/app/sections/common/footer/footer.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/common/view-more/view-more.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/srilanka-itinerary/activities/activities.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/srilanka-itinerary/customize-packages/customize-packages.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/srilanka-itinerary/Flights/flights.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/srilanka-itinerary/hero/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/srilanka-itinerary/hotels/hotels.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/srilanka-itinerary/inclusion/inclusion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/srilanka-itinerary/itinerary-block/itinerary-block.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/srilanka-itinerary/price/price.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sections/srilanka-itinerary/secondary-nav/secondary-nav.tsx");
